export const set = (property, saveTolocalStorage) => (state, payload) => {
  if (saveTolocalStorage) {
    if (typeof payload === 'object') {
      localStorage.setItem(property, JSON.stringify(payload))
    } else {
      localStorage.setItem(property, payload)
    }
  }
  (state[property] = payload)
}

export const toggle = property => state => (state[property] = !state[property])
